var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOffice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  d: "m27.21 14.28-14-4a.74.74 0 0 0-.66.12c-.19.14-.3.36-.3.6v18c0 .41.34.75.75.75h14c.41 0 .75-.34.75-.75V15a.75.75 0 0 0-.54-.72m-9.46 13.97V26c0-.14.11-.25.25-.25h4c.14 0 .25.11.25.25v2.25zm8.5 0h-2.5V26c0-.96-.79-1.75-1.75-1.75h-4c-.96 0-1.75.79-1.75 1.75v2.25h-2.5V11.99l12.5 3.57z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  d: "M16 22.75c.41 0 .75-.34.75-.75v-5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v5c0 .41.34.75.75.75m8 0c.41 0 .75-.34.75-.75v-5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v5c0 .41.34.75.75.75m-4 0c.41 0 .75-.34.75-.75v-5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v5c0 .41.34.75.75.75"
})));
export default SvgIconOffice;